import React from "react";
import './progress-bar.scss';

export class ProgressBar extends React.Component<any, any> {
    percentage: number = this.props.rating / 10 * 100;
    rating: number = this.props.rating;
    constructor(props: any) {
        super(props);
        this.state = {
            width: 0
        }
        this.progressData = this.progressData.bind(this)

    }
    componentDidMount() {
        this.progressData();
    }

    progressData() {
        let interval;

        interval = setInterval(() => {
            if (this.percentage > this.state.width) {
                this.setState({
                    width: (this.percentage > this.state.width) && this.state.width + 1
                })
            }
            else {
                clearInterval(interval)
            }
        }, 100)



    }
    render(): React.ReactNode {
        return (
            <div className="progress-wrapper">
                <div className="progress-wrapper__content">
                    <span>{this.props.name}</span>
                    <span>{this.percentage}%</span>
                </div>
                <div className="progress-wrapper__strip">
                    <div className="progress-wrapper__strip--field" style={{ width: this.state.width + '%' }}></div>
                </div>
            </div>
        )

    }
}

export default ProgressBar;